import formslive from './formslive';
import base from './base';

export default {
  'BASE': base,
  'FORMS_LIVE': formslive
}

